module.exports = __webpack_public_path__ + "static/media/011-man-2.6a43ffdc.svg";